import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  Cell,
  CartesianGrid,
} from "recharts";
import {
  Card,
  Col,
  Row,
  CardHeader,
  CardBody,
  CardFooter,
  Label,
  Button,
  DropdownItem,
  DropdownMenu,
  Dropdown,
  DropdownToggle,
} from "reactstrap";
import { Volume } from "react-feather";
import DateTimePicker from "react-datepicker";
import { useEffect, useState } from "react";
import { usePagination } from "../../hooks/usePagination";
import { format } from "date-fns";
import ApiService from "../../services/apiService";
import { toast } from "react-toastify";
import LeftIcon from "../svg/LeftButton";
import RightIcon from "../svg/RightIcon";

type chartProp = {
  fromDateTime?: string | null;
  toDateTime?: string | null;
  generateKey?: number | null | undefined;
  id?: number | string;
  selectedDashboard?: string | null;
};
const BarChar1 = ({ fromDateTime, toDateTime, generateKey }: chartProp) => {
  const [isEnabled, setIsEnabled] = useState<any>(false);
  const [pumpingStationData, setPumpingStationData] = useState<any[]>();
  const [pumpingstation, setPumpingStation] = useState<any[]>();
  const [dropdownOpen, setDropdownOpen] = useState<boolean>();
  const [selectedPumpingStation, setSelectedPumpingStation] =
    useState<string>("");
  const [allChakVolume, setAllChakVolume] = useState<any[]>();
  const [startIndex, setStartIndex] = useState(0);
  const [mergedChartData, setMergedChartData] = useState<any[]>([]);
  const [autoSlide, setAutoSlide] = useState(true);
 


  // show 10 bars at a time
 
  
  const getWindowSize = () => {
    const width = window.innerWidth;
  
    // 13–14 inch laptops usually 1280–1440px width
    if (width <= 1440) {
      return 6;
    }
  
    return 10;
  };
  const [windowSize, setWindowSize] = useState<number>(getWindowSize());

  const maxPages = Math.ceil(mergedChartData.length / windowSize);
 
  const endDate = new Date();
  const startDate = new Date();
  startDate.setDate(startDate.getDate() - 
  6);
  startDate.setHours(0, 0, 0, 0);

  const toggleDropdown = () => setDropdownOpen((prev) => !prev);

  const getLocalDateKey = (dt: string) => {
    const d = new Date(dt);
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(
      2,
      "0"
    )}-${String(d.getDate()).padStart(2, "0")}`;
  };

  const getAllChakDistribution = async () => {
    try {
      const response = await ApiService.axiosApi(
        `/chakhistory/getallchakdistribution`,
        {
          method: "GET",
          params: {
            pageNumber: 0,
            pageSize: 0,
            fromDate:
              fromDateTime == null
                ? format(startDate, "yyyy-MM-dd HH:mm:ss")
                : format(fromDateTime, "yyyy-MM-dd HH:mm:ss"),
            toDate:
              toDateTime == null
                ? format(endDate, "yyyy-MM-dd HH:mm:ss")
                : format(toDateTime, "yyyy-MM-dd HH:mm:ss"),
          },
        }
      );
      if (response.success) {
        setAllChakVolume(response.data.data);
      } else {
        console.log("unable to get all chak volume");
      }
    } catch (e) {
      console.log(e);
    }
  };

  const getPumpingStationHistory = async () => {
    try {
      const response = await ApiService.axiosApi(
        `/pumpingstation/dailyvolume`,
        {
          method: "GET",
          params: {
            pageNumber: 0,
            pageSize: 0,
            fromDate:
              fromDateTime == null
                ? format(startDate, "yyyy-MM-dd HH:mm:ss")
                : format(fromDateTime, "yyyy-MM-dd HH:mm:ss"),
            toDate:
              toDateTime == null
                ? format(endDate, "yyyy-MM-dd HH:mm:ss")
                : format(toDateTime, "yyyy-MM-dd HH:mm:ss"),
          },
        }
      );
      if (response.success) {
        const updatedData = response.data.data.map((dateTime: any) => ({
          ...dateTime,
          dateTime: format(new Date(dateTime.dateTime), "yyyy-MM-dd HH:mm:ss"),
        }));
        setPumpingStationData(updatedData);
      } else {
        toast.error("Unable to get data at this moment");
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getPumpingStationHistory();
    getAllChakDistribution();
  }, [generateKey]);

  const mergeChartData = (pumping: any[] = [], distribution: any[] = []) => {
    const map: Record<string, any> = {};

    // Pumping data
    pumping.forEach((item) => {
      const key = getLocalDateKey(item.dateTime);

      map[key] = {
        dateTime: key,
        dailyVolume: Number(item.main_Hl_Ft_Vol) || 0,
        distribution: 0,
      };
    });

    // Distribution data
    distribution.forEach((item) => {
      const key = getLocalDateKey(item.dateTime);

      if (!map[key]) {
        map[key] = {
          dateTime: key,
          dailyVolume: 0,
          distribution: 0,
        };
      }

      map[key].distribution = Number(item.allChakDistribution) || 0;
    });

    return Object.values(map).sort(
      (a: any, b: any) =>
        new Date(a.dateTime).getTime() - new Date(b.dateTime).getTime()
    );
  };

  useEffect(() => {
    if (pumpingStationData && allChakVolume) {
      const merged = mergeChartData(pumpingStationData, allChakVolume);
      console.log(merged);
      setMergedChartData(merged);
      setStartIndex(0); // reset pagination
    }
  }, [pumpingStationData, allChakVolume]);

  const handleNext = () => {
    if (
      mergedChartData &&
      startIndex + windowSize < mergedChartData.length
    ) {
      setStartIndex(startIndex + windowSize);
    }
  };

  const handlePrev = () => {
    if (startIndex - windowSize >= 0) {
      setStartIndex(startIndex - windowSize);
    }
  };
  // useEffect(() => {

  //   if (!autoSlide) return;


  //   if (mergedChartData.length <= windowSize) return; // only one page → no sliding
  
  //   const interval = setInterval(() => {
  //     setStartIndex((prev) => {
  //       const nextIndex = prev + windowSize;
  
  //       // loop back to first page
  //       if (nextIndex >= mergedChartData.length) {
  //         return 0;
  //       }
  
  //       return nextIndex;
  //     });
  //   }, 15000); // 15seconds
  
  //   return () => clearInterval(interval);
  // }, [mergedChartData.length, windowSize]);
  

  const visibleData = mergedChartData.slice(
    startIndex,
    startIndex + windowSize
  );

  return (
    <Card className="m-0 b-r-0 ">
      <CardHeader>
        <div className="d-flex justify-content-between align-items-center">
          <span>
            <h5 style={{ fontWeight: "600" }}>Distribution Vs Pumping</h5>
            <h6 style={{ fontSize: "12px" }}>
              {" "}
              {fromDateTime
                ? format(new Date(fromDateTime), "dd/MM/yyyy HH:mm:ss")
                : format(startDate, "dd/MM/yyyy ")}{" "}
              -
              {toDateTime
                ? format(new Date(toDateTime), "dd/MM/yyyy HH:mm:ss")
                : format(endDate, "dd/MM/yyyy ")}
            </h6>
          </span>

          <div className="d-flex">
            <button
              className="icon-button "
              onClick={handlePrev}
              disabled={startIndex === 0}
            >
              <LeftIcon />
            </button>

            <button
              className="icon-button"
              onClick={() => {
                setAutoSlide(false);
                handleNext();
              }}
              
              disabled={
                mergedChartData &&
                startIndex + windowSize >= mergedChartData.length
              }
            >
              <RightIcon />
            </button>
          </div>
        </div>
      </CardHeader>

      <CardBody>
        <ResponsiveContainer width="100%" height={305}>
          <BarChart data={visibleData} barCategoryGap="0%" barGap={5}>
            <XAxis
              dataKey="dateTime"
              tick={{ fontSize: 15,textAnchor: 'end' }}
              tickMargin={1}
              interval={0}
              angle={-20}  
              height={50}
              tickFormatter={(value) =>
                new Date(value).toLocaleDateString("en-GB", {
                  day: "2-digit",
                  month: "short",
                  year: "numeric",
                })
              }
            />

            <YAxis
              yAxisId="right"
              orientation="left"
             
              label={{
                value: "Distribution (m³)",
                angle: -90,
                position: "insideLeft",
                dx:-5,
                
              }}
              tick={({ x, y, payload }) => (
                <text
                  x={x}
                  y={y}
                  textAnchor="end"
                  dominantBaseline="start"
                  
                  fill="#666"
                  fontSize={12}
                >
                  {payload.value}
                </text>
              )}
            />

            {/* Right axis for Pumping */}
            <YAxis
              yAxisId="left"
              orientation="right"
        
              label={{
                value: "Pumping (m³)",
                angle: -90,
                position: "insideRight",
                dx: 2,
                dy:50
              }}
              tick={({ x, y, payload }) => (
                <text
                  x={x}
                  y={y}
                  textAnchor="start"
                  dominantBaseline="start"
                  
                  fill="#666"
                  fontSize={12}
                >
                  {payload.value}
                </text>
              )}
            />

            <Tooltip
              formatter={(value: number, name: string) => [
                `${value} m³`,
                name === "dailyVolume" ? "Pumping" : "Distribution",
              ]}
              cursor={false}
            />
             <Bar
              yAxisId="right"
              dataKey="distribution"
              barSize={30}
              fill="#2B5F60"
              label={{ position: "outside",fontSize:'12', angle: -90,fill:'#FFFFFF' }}
            >
              {visibleData.map((_, index) => (
                <Cell key={`distribution-${index}`} />
              ))}
            </Bar>

            <Bar

             yAxisId="left"
              dataKey="dailyVolume"
              barSize={30}
              fill="#DC3545"
              
              label={{ position: "outside",fontSize:'12',angle: -90,fill:'#FFFFFF' }}
            >
              {visibleData.map((_, index) => (
                <Cell key={`pumping-${index}`} />
              ))}
            </Bar>

           
          </BarChart>
        </ResponsiveContainer>
      </CardBody>
      <CardFooter className="p-0">
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "1rem",
            gap: "2rem",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
            <div
              style={{
                width: "12px",
                height: "12px",
                backgroundColor: "#2B5F60",
                borderRadius: "2px",
              }}
            />  
            <span>Distribution</span>
          </div>
            <div
              style={{
                width: "12px",
                height: "12px",
                backgroundColor: "#DC3545",
                borderRadius: "2px",
              }}
            />                                                                 
            <span>Pumping</span>
          </div>
          
        </div>
      </CardFooter>
    </Card>
  );
};

export default BarChar1;
